import { EntityLabel } from '@esg/esg-global-types';

export const group_label: EntityLabel = {
  one: 'Group',
  many: 'Groups'
};
